import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { defaultConfig } from 'src/config/default-config';
import { botswanaConfig } from 'src/config/botswana-config';
import { zimConfig } from 'src/config/zim-config';
import { coteivoryConfig } from 'src/config/Cote-ivory-config';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';
export const CountryMap: { [key: string]: string } = {
  '72': 'Botswana',
  '716': 'Zimbabwe',
  '356': 'India',      // Add more as needed
  '384': 'Côte d Ivoire'
};

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class TermsAndConditionsComponent {

  termsHtml: string = '';
  countryCode = '';


  countryInitials: any;
  countryName: any;
  appName: string = "";
  smallappName: string = "";
  logoUrl: any;
  countryConfig: any;
  country:any;
  macAddress:any;
  constructor(private dialog: MatDialog, private http: HttpClient,private cStorage:ClientSideStorageService, private route: ActivatedRoute, private router: Router) {

    const postValue = this.cStorage.get('postcountry') ?? history.state.countryConfig.country
    // this.route.queryParams.subscribe(params => {
    //   const id = params['id'];
    //   this.countryInitials = id !== undefined ? id : 'D';
    // });

    if (postValue === 'Zimbabwe') {
      this.countryName = "Zimbabawe"
      this.countryCode ='716'
    } else if (postValue === 'Botswana') {
      this.countryName = "Botswana"
      this.countryCode = '72'
    }
    else if (postValue === 'Cote De Ivory') {
      this.countryName = "Côte d Ivoire"
      this.countryCode = '384'
    }
    else {
      this.countryName = "India"
      this.countryCode = '356'
    }
    this.country = JSON.parse(this.cStorage.get("country"));
    this.macAddress = JSON.parse(this.cStorage.get("macAddress"));

    this.setAppNameBasedOnCountry();
  }

  ngOnInit() {
    debugger
    // this.route.queryParams.subscribe(params => {
    //   const country = params['country'];
      if (this.countryName) {
        // this.countryName = country
        // Now remove the query param from the browser URL
        this.countryConfig = this.getConfigByCountry(this.countryCode) ?? defaultConfig;
        this.logoUrl = this.countryConfig.headerpostlogo;
        this.loadTermsForCountryAPI(this.countryName);

        // Remove ?country=... from URL cleanly
        // this.router.navigate([], {
        //   queryParams: {},
        //   replaceUrl: true
        // });
      } else {
        this.countryName = 'country'


      }
    // });
    // this.loadTermsForCountry(this.countryCode);
  }

  setAppNameBasedOnCountry() {
    switch (this.countryName) {
      case 'India':
        this.appName = 'SHIP2MYID-POST OFFICE DEALS APP';
        this.smallappName = 'Ship2MyID-Post Office Deals App';
        break;
      case 'Botswana':
        this.appName = 'POSOKLICK DEALS APP';
        this.smallappName = 'PosoKlick Deals App';
        break;
      case 'Côte d Ivoire':
        this.appName = 'TOP DEALS CI APP';
        this.smallappName = 'Top Deals CI App';
        break;
      default:
        this.appName = 'SHIP2MYID-POST OFFICE DEALS APP';
        this.smallappName = 'Ship2MyID-Post Office Deals App';
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  // navigateFaqs() {
  //   const url = `#${this.router.serializeUrl(this.router.createUrlTree(['/faqs']))}`;
  //   window.open(url, '_blank');
  // }

  loadTermsForCountry(country: string) {
    debugger
    const url = `assets/Termsfiles/${country.toLowerCase()}.html`;
    this.http.get(url, { responseType: 'text' }).subscribe(
      html => this.termsHtml = html,
      err => this.termsHtml = '<p>Terms not available for this region.</p>'
    );
  }

  loadTermsForCountryAPI(country: any) {
    const countryName = CountryMap[country];
    const httpOptions = {
      // 'userName': 'satheshjkv@gmail.com',
      'macAddress': this.macAddress,
      'country': this.country
    };
    let countryid = parseInt(this.countryCode)
    let locale = this.countryConfig.language.toUpperCase()
    const url = environment.authUrl + `orchestration-service/admin/api/terms?country=${countryid}&type=MERCHANT&locale=${locale}&componentType=TERMS`;
    this.http.get(url, { headers: httpOptions, observe: 'response', withCredentials: true }).subscribe(
      html => this.termsHtml = (html as any).body?.data?.htmlContent,
      err => this.termsHtml = '<p>Terms not available for this region.</p>'
    );
  }


  getConfigByCountry(country: any): any {
    switch (country) {
      case '72':
        return botswanaConfig;
      case '716':
        return zimConfig;
      case "384":
        return coteivoryConfig;
      default:
        return defaultConfig;
    }

  }


}
